import React, { Fragment } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

function ReportModal(props: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const {
    title = "Write a Report",
    showModal,
    setModalVisibility,
    data,
    setData,
    endPoint,
    type
  } = props;

  const { errors, handleSubmit, register, reset } = useForm({
    defaultValues: {
      message: "",
    },
    mode: 'onChange',
  });
  const [report, { status }] = useApiMutation({
    onSuccess: () => {
      reset();
      setModalVisibility(false);
    },
  });

  const handleReport = async (params: any) => {
    if (status === "loading") {
      return;
    }
    try {
      await report({
        url: endPoint,
        data: {
          ...data,
          type: type,
          subId: user?.username,
          ...params
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    reset();
    setModalVisibility(false);
    if (setData && typeof setData === "function") {
      setData([]);
    }
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form onSubmit={handleSubmit(handleReport)}>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label className="mb-0">
                      {t(title)}
                    </label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder={t("Write a message")}
                      ref={register({ required: "*Message required" })}
                    ></textarea>
                    {errors.message && (
                      <span className="ml-3 text-danger">
                        {errors.message.message}
                      </span>
                    )}
                  </div>
                  <div className="d-sm-flex justify-content-between">
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir() === 'rtl' ? 'ml-3' : 'mr-3'}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        type="submit"
                        className="btn custom_btn fz14"
                      >
                        <VisibilityToggle visible={status === "loading"}>
                          <span className="spinner-border spinner-border-sm"></span>
                        </VisibilityToggle>
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default ReportModal;
